import { render, staticRenderFns } from "./SetBestTweetsAsEvergreenModal.vue?vue&type=template&id=6d0ba2d1&"
import script from "./SetBestTweetsAsEvergreenModal.vue?vue&type=script&lang=js&"
export * from "./SetBestTweetsAsEvergreenModal.vue?vue&type=script&lang=js&"
import style0 from "./SetBestTweetsAsEvergreenModal.vue?vue&type=style&index=0&id=6d0ba2d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports